import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TopDegreeSubject } from '../../models/course-degree-hub.models';
import { CourseGTMService } from '@uc/web/core';
import { CourseSearchLocationGAEnum } from '@uc/web/shared/data-models';

@Component({
	selector: 'uc-degree-subject-category',
	templateUrl: './degree-subject-category.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [RouterLink],
})
export class DegreeSubjectCategoryComponent {
	subjects = input.required<TopDegreeSubject>();
	basePath = input.required<string>();
	pageType = input.required<'hub' | 'directory'>();

	private _courseGTMSrv = inject(CourseGTMService);

	setSearchLocation() {
		const searchLocation =
			this.pageType() === 'hub'
				? CourseSearchLocationGAEnum.HubPageSubjectLink
				: CourseSearchLocationGAEnum.DirectoryPageSubjectLink;
		this._courseGTMSrv.setSearchLocation(searchLocation);
	}
}
